import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../style.css'
import { platformList } from './enmu';
import TimeInput from '../../../../components/TimeInput/TimeInput';
import qs from 'querystring'

class BrandExport extends React.PureComponent {
  state = {
    beginTime: '',
    endTime: '',
    platform: 'all',
    industry: '',
    charts: 'db',
    industryList: [],
  }

  change(key, value) {
    this.setState({
      [key]: value
    })
  }

  /**
   * 导出文件
   */
  exportExcel = () => {
    const { beginTime, endTime, platform, charts, industry } = this.state;
    const { brandName } = this.props;

    const params = {
      brandName: brandName,
      timeStart: beginTime,
      timeEnd: endTime,
      platform: platform,
      charts: charts
    };
    if (industry) {
      params.industry = industry
    }

    const begin = params.timeStart.split('-').join('');
    const end = params.timeEnd.split('-').join('');

    if (begin > end) {
      return alert('开始时间不能小于结束时间！')
    } else if (params.brandName === '') {
      return alert('请填写上方品牌名称！')
    }


    const url = `/dbrankCMS/saveBrandChartsData?${qs.stringify(params)}`
    console.log(url);

    window.open(url, "_blank")
  }

  render() {
    const { industryList, beginTime, endTime, platform, industry, charts } = this.state;

    return (
      <div className={s.wrapper} style={{ background: '#fff', border: '1px solid #ebedf0', borderRadius: 0 }}>
        <div className={s.item}>
          <label className={s.label}>开始时间：</label>
          <TimeInput className={s.input} value={beginTime} onChange={val => this.change('beginTime', val)} />
        </div>

        <div className={s.item}>
          <label className={s.label}>结束时间：</label>
          <TimeInput className={s.input} value={endTime} onChange={val => this.change('endTime', val)} />
        </div>

        <div className={s.item}>
          <label className={s.label}>选择平台：</label>
          <select className={s.input} value={platform} onChange={e => this.change('platform', e.target.value)}>
            {platformList.map(item => <option value={item.type} key={item.type}>{item.class}</option>)}
          </select>
        </div>

        <div className={s.item}>
          <label className={s.label}>选择行业：</label>
          <select className={s.input} value={industry} onChange={e => this.change('industry', e.target.value)}>
            <option value="">所有行业</option>
            {industryList.map((item, index) => <option value={item} key={index}>{item}</option>)}
          </select>
        </div>

        <div className={s.item}>
          <label className={s.label}>勾选所需数据：</label>
          <select className={s.input} value={charts} onChange={e => this.change('charts', e.target.value)}>
            <option value="db">DB值</option>
            <option value="dbDay">DB值(单日)</option>
            <option value="dimensions">三维度值</option>
            <option value="dimensionsDay">三维度值(单日)</option>
            <option value="kolPa">KOL参与情况</option>
            <option value="favorability">受众好感</option>
            <option value="sensation">口碑舆情图</option>
          </select>
        </div>

        <hr />

        <div style={{ paddingLeft: '100px' }}>
          <button className={s.btn} type="button" onClick={this.exportExcel}>导出</button>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(BrandExport)



// WEBPACK FOOTER //
// src/routes/cms/components/BrandComponent/BrandExport.js